import PropTypes from 'prop-types';

import styles from './Badge.module.scss';

const Badge = ({ label, color, bgColor, customClass }) => (
  <div className={`${styles.container} ${customClass || ''}`} style={{ color, backgroundColor: bgColor }} data-test-id="badge">
    <span className={styles.label}>{label}</span>
  </div>
);

Badge.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  customClass: PropTypes.string
};

export default Badge;
